import angular from 'angular'

import wagonAsk from './services/ask.service'
import wagonData from './services/data.service'
import wagonFormat from './services/format.service'
import wagonGo from './services/go.service'
import wagonLocal from './services/local.service'
import wagonMetadata from './services/metadata.service'
import wagonNew from './services/new.service'
import wagonRequest from './services/request.service'
import wagonResource from './services/resource.service'
import wagonTest from './services/test.service'
import wagonUtils from './services/utils.service'
import wagon from './services/wagon.service'

import myWagonDisplay from './directives/display/myWagonDisplay'
import myWagonDisplayDispositions from './directives/display/myWagonDisplayDispositions'
import myWagonDisplayFields from './directives/display/myWagonDisplayFields'
import myWagonDisplayHeader from './directives/display/myWagonDisplayHeader'
import myWagonDisplayMovements from './directives/display/myWagonDisplayMovements'
import myWagonDisplayScrapping from './directives/display/myWagonDisplayScrapping'
import myWagonDisplayTrains from './directives/display/myWagonDisplayTrains'
import myDispositionForm from './directives/forms/myDispositionForm'
import myDispositionsForm from './directives/forms/myDispositionsForm'
import myWagonForm from './directives/forms/myWagonForm'
import myCopyWagonsInput from './directives/inputs/myCopyWagonsInput'
import myWagonInputId from './directives/inputs/myWagonInputId'
import myWagonPartId from './directives/inputs/myWagonPartId'
import myWagonRevision from './directives/inputs/myWagonRevision'
import myWagonSearch from './directives/search/myWagonSearch'

import myWagonIdSearch from './directives/search/myWagonIdSearch'
import myWagonOwnerSearch from './directives/search/myWagonOwnerSearch'
import myWagonRailwaySearch from './directives/search/myWagonRailwaySearch'
import myWagonTrainSearch from './directives/search/myWagonTrainSearch'

import wagonButtons from './resources/buttons.resource'
import wagonFields from './resources/fields.resource'
import wagonIcons from './resources/icons.resource'
import wagonLabels from './resources/labels.resource'

import editDispositionModal from './modals/editDisposition.modal'
import editDispositionsModal from './modals/editDispositions.modal'
import editFieldModal from './modals/editField.modal'
import editFieldsModal from './modals/editFields.modal'
import editOwnerModal from './modals/editOwner.modal'
import editOwnersModal from './modals/editOwners.modal'
import parkIdNewModal from './modals/parkIdNew.modal'

const name = 'wagon'

angular.module(name, [])
  // ===== SERVICES ===== //
  .factory('wagonAsk', wagonAsk)
  .factory('wagonData', wagonData)
  .factory('wagonFormat', wagonFormat)
  .factory('wagonGo', wagonGo)
  .factory('wagonLocal', wagonLocal)
  .factory('wagonMetadata', wagonMetadata)
  .factory('wagonNew', wagonNew)
  .factory('wagonRequest', wagonRequest)
  .factory('wagonResource', wagonResource)
  .factory('wagonTest', wagonTest)
  .factory('wagonUtils', wagonUtils)
  .factory('$$wagon', wagon)
  // ===== DIRECTIVES ===== //
  .directive('myWagonDisplay', myWagonDisplay)
  .directive('myWagonDisplayFields', myWagonDisplayFields)
  .directive('myWagonDisplayDispositions', myWagonDisplayDispositions)
  .directive('myWagonDisplayHeader', myWagonDisplayHeader)
  .directive('myWagonDisplayMovements', myWagonDisplayMovements)
  .directive('myWagonDisplayScrapping', myWagonDisplayScrapping)
  .directive('myWagonDisplayTrains', myWagonDisplayTrains)
  .directive('myWagonForm', myWagonForm)
  .directive('myCopyWagonsInput', myCopyWagonsInput)
  .directive('myWagonInputId', myWagonInputId)
  .directive('myWagonPartId', myWagonPartId)
  .directive('myWagonRevision', myWagonRevision)
  .directive('myWagonSearch', myWagonSearch)
  .directive('myWagonIdSearch', myWagonIdSearch)
  .directive('myWagonOwnerSearch', myWagonOwnerSearch)
  .directive('myWagonRailwaySearch', myWagonRailwaySearch)
  .directive('myWagonTrainSearch', myWagonTrainSearch)
  .directive('myDispositionsForm', myDispositionsForm)
  .directive('myDispositionForm', myDispositionForm)
  // ===== RESOURCES ===== //
  .factory('wagonButtons', wagonButtons)
  .factory('wagonIcons', wagonIcons)
  .factory('wagonFields', wagonFields)
  .factory('wagonLabels', wagonLabels)
  // ===== MODALS ===== //
  .factory('editFieldModal', editFieldModal)
  .factory('editFieldsModal', editFieldsModal)
  .factory('editOwnerModal', editOwnerModal)
  .factory('editOwnersModal', editOwnersModal)
  .factory('editDispositionModal', editDispositionModal)
  .factory('editDispositionsModal', editDispositionsModal)
  .factory('parkIdNewModal', parkIdNewModal)

export default 'wagon'



// WEBPACK FOOTER //
// ./public/javascript/sygem/entities/trains/wagon/wagon.module.js